<template>
	<div class="container testimonials-product-reviews-carousel">
		<div class="row">
			<div class="col-lg-8 col-md-8 mx-md-auto">
				<swiper :options="swiperOptions" class="swiper" ref="swiper"
				>
					<swiper-slide v-for="(testimonial, index) in testimonials"
								  class="testimonials-product-reviews-carousel__thumb" :class="`slide-${index}`"
								  :key="index">
						<div class="slide-wrapper">
							<div class="content">
								<div>
									<svg class="quotes" xmlns="http://www.w3.org/2000/svg"
										 viewBox="210.7373 110.173 90.9527 82.991" width="90.9527px" height="82.991px">
										<g id="object-2"
										   transform="matrix(1.0000000000000002, 0, 0, 1.0000000000000002, 0, 0)">
											<path
												d="M 237.949 110.173 C 210.217 129.836 203.384 162.935 218.82 193.074 L 247.836 180.943 C 240.598 159.408 239.216 143.816 254.424 122.509 L 237.949 110.173 Z"
												style="stroke-width: 1;" id="object-0"/>
											<path
												d="M 285.215 110.263 C 257.483 129.926 250.65 163.025 266.086 193.164 L 295.102 181.033 C 287.864 159.498 286.482 143.906 301.69 122.599 L 285.215 110.263 Z"
												style="stroke-width: 1;" id="object-1"/>
										</g>
									</svg>
									<p v-text="testimonial.content"></p>
								</div>
								<div class="name" v-text="testimonial.name"></div>
							</div>
						</div>
					</swiper-slide>

					<div v-show="canSwipe" class="swiper-button-prev" slot="button-prev"
						 id="swiper-prev-testimonials-product-reviews">
						<svg class="ticon ticon-180">
							<use xlink:href="/images/icons.svg?v1.3#icon-arrow-right"></use>
						</svg>
					</div>
					<div v-show="canSwipe" class="swiper-button-next" slot="button-next"
						 id="swiper-next-testimonials-product-reviews">
						<svg class="ticon">
							<use xlink:href="/images/icons.svg?v1.3#icon-arrow-right"></use>
						</svg>
					</div>
				</swiper>
			</div>
		</div>
	</div>
</template>

<script>

import {Swiper, SwiperSlide} from 'vue-awesome-swiper'

export default {
	name: 'TestimonialsProductReviewsCarousel',
	components: {
		Swiper,
		SwiperSlide
	},
	props: {
		testimonials: Array
	},

	data() {
		let breakpoints = {
			tablet: 768,
			desktop: 1200,
		};

		let slidesPerView = {
			mobile: 1,
			tablet: 2,
			desktop: 3,
		};

		console.log("mobile",this.calculateSlidesPerGroup(slidesPerView.mobile));
		console.log("tablet",this.calculateSlidesPerGroup(slidesPerView.tablet));
		console.log("desktop",this.calculateSlidesPerGroup(slidesPerView.desktop));

		return {
			breakpoints: breakpoints,
			slidesPerView: slidesPerView,
			windowWidth: window.innerWidth,
			swiperOptions: {
				autoHeight: true,
				loop: true,
				loopFillGroupWithBlank: true,
				allowTouchMove: false,
				slidesPerView: slidesPerView.mobile,
				slidesPerGroup: this.calculateSlidesPerGroup(slidesPerView.mobile),
				spaceBetween: 30,
				navigation: {
					nextEl: '#swiper-next-testimonials-product-reviews',
					prevEl: '#swiper-prev-testimonials-product-reviews'
				},
				breakpoints: {
					[breakpoints.tablet]: {
						slidesPerView: slidesPerView.tablet,
						slidesPerGroup: this.calculateSlidesPerGroup(slidesPerView.tablet),
					},
					[breakpoints.desktop]: {
						slidesPerView: slidesPerView.desktop,
						slidesPerGroup: this.calculateSlidesPerGroup(slidesPerView.desktop),
					}
				},
				on: {
					resize: () => {
						this.windowWidth = window.innerWidth;
					},

				}

			},
		}
	},
	methods: {
		calculateSlidesPerGroup(slidesPerView) {
			return this.testimonials.length > slidesPerView ? 1 : slidesPerView;
		},
	},
	computed: {
		canSwipe() {
			let slidesPerView;
			if (this.windowWidth >= this.breakpoints.desktop) {
				slidesPerView = this.slidesPerView.desktop;
			} else if (this.windowWidth >= this.breakpoints.tablet) {
				slidesPerView = this.slidesPerView.tablet;
			} else {
				slidesPerView = this.slidesPerView.mobile;
			}
			return Math.max(slidesPerView, this.testimonials.length) > slidesPerView;
		}
	}


}

</script>
